var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { HttpService } from './../common/http.service';
import { Injectable } from '@angular/core';
var FavouriteLocationService = /** @class */ (function () {
    function FavouriteLocationService(httpService) {
        this.httpService = httpService;
    }
    FavouriteLocationService.prototype.addFavouriteLocation = function (data) {
        return this.httpService.post('/formeditor/favoritelocation', data);
    };
    FavouriteLocationService.prototype.listFavouriteLocation = function (data) {
        return this.httpService.get('/formeditor/favoritelocation', data);
    };
    FavouriteLocationService.prototype.deleteFavouriteLocation = function (data) {
        return this.httpService.delete('/formeditor/favoritelocation', data);
    };
    FavouriteLocationService.prototype.editFavouriteLocation = function (data) {
        return this.httpService.put('/formeditor/favoritelocation', data);
    };
    FavouriteLocationService = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [HttpService])
    ], FavouriteLocationService);
    return FavouriteLocationService;
}());
export { FavouriteLocationService };



//////////////////
// WEBPACK FOOTER
// ./src/app/favourite-location/favourite-location.service.ts
// module id = ./src/app/favourite-location/favourite-location.service.ts
// module chunks = main